<template>
  <div v-if="communityId != null">
    <div
      v-for="data in metaData" :key="data.id"
    >
      <b-card
        :title="metaData.name"
        tag="article"
        class="main-box"
        v-if="data.infoBlocks.length"
      >
        <template v-for="info in data.infoBlocks">
          <p v-if="info.type === 'TEXT'" :key="info.id">
            <vue-simple-markdown :source="info.text" />
          </p>
          <p v-else-if="info.type === 'BUTTON'" :key="info.id">
            <b-icon icon="arrow-up-right-square" class="pdf-icon"></b-icon>
            <a class="info-link" :href="info.url" target="_blank">{{ info.text }}</a>
          </p>
        </template>
      </b-card>
    </div>
  </div>
</template>

<script>
  import { mapState } from 'vuex'
  import { errorHandler } from '@/helpers/formHelper.js'

  export default {
    data: () => ({
      hasUnknownError: false,
      unknownErrorMessage: '',
      metaData: {}
    }),
    created () {
      this.getCommunityInfo()
    },
    methods: {
      async getCommunityInfo () {
        this.hasUnknownError = false
        this.hasError = false

        this.$store.dispatch('community/GET_COMMUNITY_INFO', this.communityId).then(res => {
          const { errors, data } = res

          if (errors) {
            return errorHandler(this, errors)
          }

          this.metaData = data
        }).catch(err => {
          this.hasUnknownError = true
          this.unknownErrorMessage = this.$t('formError.unknownwError')
          console.error(err)
        })
      }
    },
    computed: {
      ...mapState({
        communityId: state => state.calculator.communityId
      })
    },
    watch: {
      communityId (newValue, oldValue) {
        if (newValue !== oldValue && !this.isPropertyModalVisible) {
          this.getCommunityInfo()
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  .main-box::v-deep{
    padding: 0;

     &.card{
       margin: 1rem 0;
     }
  }

  .card-body{
    p:last-child{
      margin-bottom: 0;
    }
  }

  .application-wrapper {
    a{
      text-decoration: none;
    }
  }

  .pdf-icon{
    margin-right: 0.5rem;
    font-size: 18px;
    color: $primary;
  }

  .info-link{
    color: $black-80;
    font-size: 0.94308rem;
  }
</style>
